import {BaseModel} from "@/model/Model";
import Location from "@/model/Location";

export default class CompanyLocation extends BaseModel<CompanyLocation> {
    location = new Location()
}
